import { useEffect, useRef, useState, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { LoadingState } from '../routes/components/LoadingState'
import { getSafeReturnTo } from './oidc'
import { useAuth } from './AuthContext'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status, configured, signingOut, signIn } = useAuth()
  const location = useLocation()
  const started = useRef(false)
  const [signInFailed, setSignInFailed] = useState(false)
  const returnTo = getSafeReturnTo(`${location.pathname}${location.search}${location.hash}`)

  useEffect(() => {
    if (configured && status === 'signed-out' && !signingOut && !started.current) {
      started.current = true
      void signIn(returnTo).catch(() => {
        started.current = false
        setSignInFailed(true)
      })
    }
  }, [configured, returnTo, signIn, signingOut, status])

  if (!configured) {
    return (
      <main className="auth-screen" role="alert">
        Authentication is not configured.
      </main>
    )
  }
  if (signInFailed) {
    return (
      <main className="auth-screen" role="alert">
        <section className="auth-card">
          <h1>We could not start sign in.</h1>
          <button
            type="button"
            onClick={() => {
              setSignInFailed(false)
              void signIn(returnTo).catch(() => setSignInFailed(true))
            }}
          >
            Try again
          </button>
        </section>
      </main>
    )
  }
  if (status !== 'authenticated') return <LoadingState />
  return <>{children}</>
}
